const plans = {
  1: {
    noCliparaLogo: false,
    id: 1,
    name: 'STARTER',
    displayName: 'Starter',
    subtitle: 'Get a taste of what Clipara can do.',
    isFree: true,
    trialDays: 0,
    numberOfVideos: 5,
    duration: 5 * 60,
    storageLimitsDisplay: '5 mins video storage',
    streamingLimitsDisplay: '100 mins video streaming/mo',
    subfeatures: ['Shareable links', 'Interactive video', 'Analytics'],
    price: 0
  },
  2: {
    noCliparaLogo: false,
    id: 2,
    name: 'BASIC',
    trialDays: 14
  },
  3: {
    noCliparaLogo: true,
    id: 3,
    name: 'PRO',
    trialDays: 14
  },
  4: {
    noCliparaLogo: true,
    id: 4,
    name: 'SCALE',
    trialDays: 14,
    numberOfVideos: 250
  },
  5: {
    noCliparaLogo: false,
    id: 5,
    name: 'BASIC',
    displayName: 'Basic',
    subtitle: 'The fastest and smartest video on the web.',
    trialDays: 14,
    duration: 60 * 60,
    durationMinutes: 60,
    storageLimitsDisplay: '60 mins video storage',
    streamingLimitsDisplay: '2,500 mins video streaming/mo',
    subfeatures: ['Add your branding', '100s of designs', 'Fast device optimised video streaming'],
    price: 24,
    annualPrice: 228
  },
  6: {
    noCliparaLogo: true,
    id: 6,
    name: 'PRO',
    displayName: 'Pro',
    subtitle: 'Make it completely your own.',
    trialDays: 14,
    duration: 180 * 60,
    durationMinutes: 180,
    storageLimitsDisplay: '3 hours video storage',
    streamingLimitsDisplay: '100 hrs video streaming/mo',
    subfeatures: ['Remove Clipara branding', 'Longer uploads'],
    subfeaturesTitle: 'Everything in Basic, plus:',
    price: 79,
    annualPrice: 756
  },
  7: {
    noCliparaLogo: true,
    id: 7,
    name: 'SCALE',
    displayName: 'Scale',
    subtitle: 'Video that means business..',
    trialDays: 14,
    duration: 1000 * 60,
    durationMinutes: 1000,
    storageLimitsDisplay: '17 hours video storage',
    streamingLimitsDisplay: '400 hrs video streaming/mo',
    subfeatures: ['1:1 Slack & premium support', 'Branded links'],
    subfeaturesTitle: 'Everything in Pro, plus:',
    price: 249,
    annualPrice: 2388
  }
}

export const isProPlan = (user) => {
  if (!user) {
    return false
  }
  const planId = user.shopifyPlanId || user.stripePlanId
  if (!planId) {
    return false
  }
  return planId === 3 || planId === 4 || planId === 6 || planId === 7
}

export const isBasicPlan = (user) => {
  if (!user) {
    return false
  }
  const planId = user.shopifyPlanId || user.stripePlanId
  if (!planId) {
    return false
  }
  return planId === 2 || planId === 5
}

export const isFreePlan = (user) => {
  if (!user) {
    return false
  }
  const planId = user.shopifyPlanId || user.stripePlanId
  if (!planId) {
    return true
  }
  return plans[planId].isFree
}

export const getNumberOfAllowedVideos = (user) => {
  if (!user) {
    return false
  }
  const planId = user.shopifyPlanId || user.stripePlanId
  if (!planId) {
    return plans[1].numberOfVideos
  }
  return plans[planId].numberOfVideos
}

export const getAllowedVideoDuration = (user) => {
  if (!user) {
    return false
  }
  const planId = user.shopifyPlanId || user.stripePlanId
  if (!planId) {
    return plans[1].duration
  }
  return plans[planId].duration
}

export const hasHitVideoLimit = (user, numberVideos) => {
  const limit = getNumberOfAllowedVideos(user)
  if (!limit) {
    return false
  }
  return numberVideos >= limit
}

export const getPlanName = (user) => {
  if (!user) {
    return false
  }
  const planId = user.shopifyPlanId || user.stripePlanId
  if (!planId) {
    return plans[1].name.toLowerCase()
  }
  return plans[planId].name.toLowerCase()
}

export const isScalePlan = (user) => {
  if (!user) {
    return false
  }
  const planId = user.shopifyPlanId || user.stripePlanId
  if (!planId) {
    return false
  }
  return planId === 4 || planId === 7
}

export default plans
